import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
    },
    header: {
      marginTop: '2rem',
      display: 'flex',
      alignItems: 'start',
      gap: '1.2rem',

      '& > .MuiIconButton-root svg': {
        width: '0.8em',
        height: '0.8em',
      },

      '& > div': {
        '& > h2': {
          fontSize: '2.4rem',
          fontWeight: 500,
          marginBottom: '0.6rem',
        },

        '& > h5': {
          fontFamily: theme.typography.body1.fontFamily,
          fontSize: '1.6rem',
          fontWeight: 600,
          color: theme.palette.text.secondary,
        },
      },
    },

    content: {
      flex: '1 1 0',
      overflowY: 'auto',
      marginTop: '1.4rem',
      display: 'grid',
      gridTemplateColumns: '1.4fr 1fr',
      gridTemplateRows: 'minmax(0, 1fr)',
      gap: '1.6rem',
    },

    resume: {
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',

      '& > span': {
        fontSize: '1.4rem',
        fontWeight: 600,
      },

      '& > div': {
        minHeight: 374,
        overflowY: 'auto',

        '& > div': {
          minHeight: 0,
        },
      },
    },

    files: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.2rem',
    },
    dropzone: {
      '& > p': {
        fontSize: '1.6rem',
        fontWeight: 600,
        marginBottom: '0.4rem',
      },

      '& > label': {
        height: 90,

        '&[data-selected=true]': {
          width: 'calc(100% - 4px)',
          margin: '0 auto',

          border: 'none',
          boxShadow:
            '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',

          '&[data-error=true]': {
            border: `1px solid ${theme.palette.error.light}`,
          },
        },

        '& h3': {
          maxWidth: '90%',
        },
        '& span': {
          color: theme.palette.secondary.main,
        },
        '& button': {
          marginRight: '2.4rem',
        },
        '& .MuiSvgIcon-root': {
          color: '#8F918C',
        },
      },
    },

    map: {
      '& > span': {
        fontSize: '1.4rem',
        fontWeight: 600,
      },

      '& > div': {
        paddingTop: '1.2rem',
        width: '100%',
        height: 370,
      },
    },

    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '1rem',
      margin: '2.2rem 0 1rem',

      '& > button': {
        margin: 0,
        width: 'fit-content',

        '&:nth-child(2)': {
          marginLeft: 'auto',
        },
      },
    },
  }),
)
